import axios from 'axios';
import qs from 'qs';

export const getLessonsRatings = (params: Record<string, any>) =>
  axios.get(`/api/v1/lesson-rates?${qs.stringify(params)}`);

export const getLessonRatingsStats = (params: { courseId: string }) =>
  axios.get(`/api/v1/lesson-rates/stats?${qs.stringify(params)}`);

export const getSchoolLessonRatingsStats = ({
  schoolId,
  params,
}: {
  schoolId: string;
  params: { courseId: string };
}) =>
  axios.get(
    `/api/v1/schools/${schoolId}/lesson-rates/stats?${qs.stringify(params)}`,
  );

export const getLessonsRatingsByStudentId = ({
  studentId,
  params,
}: {
  studentId: string;
  params: Record<string, any>;
}) =>
  axios.get(
    `/api/v1/lesson-rates/students/${studentId}?${qs.stringify(params)}`,
  );
